var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("terms-form", {
        staticClass: "mb-5",
        attrs: {
          corporation: _vm.customerCorporation,
          type: _vm.type,
          terms: _vm.terms,
          "is-embed": true
        },
        on: { load: _vm.load, "terms-accepted": _vm.saveCart },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$filters.capitalize(
                        _vm.$l10n.__("valider mon abonnement")
                      )
                    ) +
                    "\n        "
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }